


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted, Component } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import MenuTypeConst from '../../../../domain/Constants/MenuTypeConst';
import ControlTypeConst from '../../../../domain/Constants/ControlTypeConst';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_menu',
    components: {
    },
    props:
    {

        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //
        
        const store = useStore();
        const { vmodel, getPropertyValue, getPropertyBooleanValue, getPropertyNumberValue, loaded, 
            baseOnMounted, baseOnBeforeUnmount, baseOnUnmount,
            buildMenu, getLayoutComponent ,fieldKey,fieldKeyComponentDataSourceId} = ComponentCommon(props, context,store);
        const items = buildMenu();

        const clickf = ref(new Function());

        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }


        onMounted(() => {
            baseOnMounted();
        })

        onBeforeUnmount(() => {
            baseOnBeforeUnmount();
        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            getPropertyNumberValue,
            vmodel,
            MenuTypeConst,
            loaded,
            BaseControlTypeConst,
            items,
            ControlTypeConst,
            getLayoutComponent,
            fieldKey,
            fieldKeyComponentDataSourceId

        };
    },
});
